import styled from '@emotion/styled';
import { Avatar, tokens } from '@hotjar/hotsauce';

const ContainerDiv = styled.div<{ sizeInPx: number }>`
  background-color: ${tokens.color.ui_background};
  border: ${({ sizeInPx }) => (3 / 32) * sizeInPx}px solid ${tokens.color.white};
  border-radius: 50%;
  filter: drop-shadow(1px 0px 2px #c3c3c3);
  display: flex;
  justify-content: center;
  align-items: center;
`;

enum SizeEnum {
  s = 's',
  m = 'm',
  l = 'l',
  xl = 'xl',
}

interface Props {
  userName: string;
  src?: string;
  size?: 's' | 'm' | 'l' | 'xl';
}

const sizeInPxByName: { [name in SizeEnum]: number } = {
  s: 16,
  m: 24,
  l: 32,
  xl: 48,
};

export const ReactionAvatar = ({ userName, src, size = 's' }: Props): JSX.Element => {
  const sizeInPx = sizeInPxByName[size];
  return (
    <ContainerDiv sizeInPx={sizeInPx}>
      <Avatar src={src} userName={userName} hideTooltip size={size} />
    </ContainerDiv>
  );
};
